import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { AboutSection } from "@/components/AboutSection";
import { WhyChoose } from "@/components/WhyChoose";
import { SpecialistsSection } from "@/components/SpecialistsSection";
import { BrandMarquee } from "@/components/BrandMarquee";
import { AppointmentSection } from "@/components/AppointmentSection";
import { CLINIC_PHOTOS } from "@/data/site";

export default function About() {
  return (
    <Page>
      <PageHero
        crumb="About"
        overline="About DASH Clinic"
        title={"Care That Helps You Move,\nCommunicate & Live Better"}
        subtitle="A comprehensive physiotherapy, speech and hearing care center in Belpahar, Odisha — built around individualized, patient-centered care."
        image={CLINIC_PHOTOS.reception}
      />
      <AboutSection withCta={false} />
      <BrandMarquee />
      <WhyChoose />
      <SpecialistsSection />
      <AppointmentSection />
    </Page>
  );
}
